import { createSlice } from '@reduxjs/toolkit';
import { findSelectLocationManagement, searchSelectLocationManagement, getSelectLocationManagement } from './api';
import { initialState } from './api/interface';

const selectLocationManagementSlice = createSlice({
  name: 'selectLocationManagement',
  initialState,
  reducers: {
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
    },
    setHasMoreToFalse: (state, action) => {
      state.hasMore = action.payload.hasMore;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findSelectLocationManagement.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findSelectLocationManagement.fulfilled, (state, action) => {
      state.data.push(...action.payload.data);
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
      state.hasMore = action.payload.data.length < 10 ? false : true;
    });
    builder.addCase(findSelectLocationManagement.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
    builder.addCase(searchSelectLocationManagement.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(searchSelectLocationManagement.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
      state.hasMore = action.payload.data.length < 10 ? false : true;
    });
    builder.addCase(searchSelectLocationManagement.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
    builder.addCase(getSelectLocationManagement.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getSelectLocationManagement.fulfilled, (state, _) => {
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(getSelectLocationManagement.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });
  },
});

export const { setSkip, setHasMoreToFalse, setStatus, reset } =
  selectLocationManagementSlice.actions;
export default selectLocationManagementSlice.reducer;
